


























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import InputError from '~/components/inputs/InputError.vue';

type Item = {
  id: number;
  name: number | string
}

@Component({
  components: { InputError },
})
export default class SelectInput extends Vue {
  @Prop(String) customLabel: '';
  @Prop(String) customTrackBy : '';
  @Prop(String) placeholder: '';
  @Prop(Array) options: [];
  @Prop(String) openDirection: '';
  @Prop([Object, String, Number, Array]) value: string | number | {} | [] | null | undefined;
  @Prop(Object) v: () => ({});
  @Prop(Object) vMessages: () => ({});
  @Prop([Object, String, Number]) defaultValue: () => ({});
  @Prop(Boolean) disabled: false;
  @Prop(Boolean) noLabel: false;

  /* Computed if multiselect plugin will allow multi or single select */
  get multipleType () {
    return this.value && this.value.constructor === Array;
  }

  /* Destructuring v-model in a getter/setter to have a custom input container */
  get inputValue () {
    return this.value;
  }

  /* ⬆️ */
  set inputValue (value) {
    this.$emit('input', value);
  }

  /*
    This watcher is triggered when parent provides a defaultValue calculated on
    its side. The function bellow will update the v-model based on its typeof
  */
  @Watch('defaultValue', { immediate: true })
  function (val: string | number | {}) {
    if (val) {
      if (typeof val === 'string' || typeof val === 'number') {
        this.inputValue = this.options.find((el: Item) => el.id === Number(val));
      } else {
        this.inputValue = val;
      }
    } else {
      this.inputValue = null;
    }
  }
}
